var _g, _path, _path2, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgSecure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 303,
    height: 173,
    fill: "none",
    viewBox: "0 0 303 173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 30,
    x: 190,
    y: 14,
    fill: "#DFF6F1",
    rx: 6
  }), /*#__PURE__*/React.createElement("mask", {
    id: "d2r7vsmhfa",
    width: 20,
    height: 20,
    x: 194,
    y: 16,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M194.391 16H213.89V35.466H194.391z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#d2r7vsmhfa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DFF6F1",
    d: "M194.391 16H213.89V35.466H194.391z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.14,
    cy: 24.806,
    fill: "#84EAC3",
    rx: 3.25,
    ry: 3.244
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.14,
    cy: 35.002,
    fill: "#84EAC3",
    rx: 7.273,
    ry: 6.025
  })), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 4,
    x: 217,
    y: 23,
    fill: "#84EAC3",
    opacity: 0.6,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 4,
    x: 217,
    y: 31,
    fill: "#84EAC3",
    opacity: 0.6,
    rx: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#53E3AC",
    d: "M150.712 19L99.31 40.068v48.757c0 23.115 37.057 48.758 52 54.175 30.482-13.243 52-39.126 52-54.175V40.068L150.712 19z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: "M128.045 78.57l20.716 16.169 25.896-28.166"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 33,
    x: 49,
    y: 53,
    fill: "#F9F3BA",
    fillOpacity: 0.95,
    rx: 7
  }), /*#__PURE__*/React.createElement("mask", {
    id: "y62ze41p5b",
    width: 23,
    height: 22,
    x: 53,
    y: 55,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M53.939 55.203H75.42099999999999V76.649H53.939z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#y62ze41p5b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F9F3BA",
    fillOpacity: 0.95,
    d: "M53.939 55.203H75.42099999999999V76.649H53.939z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.68,
    cy: 64.905,
    fill: "#FFD324",
    rx: 3.58,
    ry: 3.574
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.68,
    cy: 76.138,
    fill: "#FFD324",
    rx: 8.013,
    ry: 6.638
  })), /*#__PURE__*/React.createElement("rect", {
    width: 25.339,
    height: 4.407,
    x: 78.847,
    y: 62.915,
    fill: "#FFD324",
    opacity: 0.8,
    rx: 2.203
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.831,
    height: 4.407,
    x: 78.847,
    y: 71.729,
    fill: "#FFD324",
    opacity: 0.8,
    rx: 2.203
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 38,
    x: 176,
    y: 102,
    fill: "#BBDCFF",
    fillOpacity: 0.7,
    rx: 8
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b26v0sihlc",
    width: 26,
    height: 26,
    x: 181,
    y: 104,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M181.853 104.542H206.64000000000001V129.287H181.853z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#60B0FF",
    mask: "url(#b26v0sihlc)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 194.246,
    cy: 115.736,
    rx: 4.131,
    ry: 4.124
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 194.246,
    cy: 128.698,
    rx: 9.246,
    ry: 7.659
  })), /*#__PURE__*/React.createElement("rect", {
    width: 29.237,
    height: 5.085,
    x: 210.593,
    y: 113.441,
    fill: "#60B0FF",
    opacity: 0.8,
    rx: 2.542
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.881,
    height: 5.085,
    x: 210.593,
    y: 123.61,
    fill: "#60B0FF",
    opacity: 0.8,
    rx: 2.542
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSecure);
export default __webpack_public_path__ + "static/media/img_secure.6325ec8a.svg";
export { ForwardRef as ReactComponent };